type Props = {
  children: React.ReactNode
}

export default function CardBody({ children }: Props) {
  return (
    <div className='divide-y divide-zinc-200 dark:divide-zinc-800 px-4 py-2 text-sm/6 dark:text-zinc-400 bg-white dark:bg-transparent'>
      {children}
    </div>
  )
}
